//Sweet alert
import Swal from "sweetalert2";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: false,
  didOpen: (toast) => {
    toast.addEventListener("mouseenter", Swal.stopTimer)
    toast.addEventListener("mouseleave", Swal.resumeTimer)
  }
});

/**
 * @param {String} type  The toast type, can be ["error", "success", "info"].
 * @param {String} title The toast title.
 * @param {String} text  The description of toast alert.
 */
const openToast = (type, title, text) => {
  Toast.fire({
    icon: type,
    title,
    text
  });
};

export default openToast;